import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useActivePDAList = () => {
  const [loading, setLoading] = useState(false);
  const [activePDAList, setActivePDAList] = useState([]);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getActivePDAList = params => {
    setLoading(true);

    axiosClient
      .get(`InventoryAgent/List?GUID=${params.guid}`)
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          const orderedList = res.data.value?.map(element => ({
            guid: element.guid,
            fullname: element.fullname,
            status: element.status, // 1: offline, 2: online
          }));
          setActivePDAList(orderedList || []);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getActivePDAList, loading, activePDAList, pageRef };
};

export default useActivePDAList;
